import axios from "axios";

const prepareData = (data) => {
  return { project_qa_ndt_bookings_ndt_type: data };
};

export const GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPES = "get_project_qa_ndt_bookings_ndt_types";
export const getProjectQaNdtBookingsNdtTypes = () => {
  const url = "/project/qa/ndt_bookings/ndt_types.json";
  const request = axios.get(url);
  return {
    type: GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPES,
    payload: request,
  };
};

export const CREATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE = "create_project_qa_ndt_bookings_ndt_type";
export const createProjectQaNdtBookingsNdtType = (data) => {
  const url = "/project/qa/ndt_bookings/ndt_types.json";
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
    payload: request,
  };
};

export const GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE = "get_project_qa_ndt_bookings_ndt_type";
export const getProjectQaNdtBookingsNdtType = (id) => {
  const url = `/project/qa/ndt_bookings/ndt_types/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
    payload: request,
  };
};

export const UPDATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE = "update_project_qa_ndt_bookings_ndt_type";
export const updateProjectQaNdtBookingsNdtType = (id, data) => {
  const url = `/project/qa/ndt_bookings/ndt_types/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
    payload: request,
  };
};

export const DESTROY_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE = "destroy_project_qa_ndt_bookings_ndt_type";
export const destroyProjectQaNdtBookingsNdtType = (id) => {
  const url = `/project/qa/ndt_bookings/ndt_types/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
    payload: request,
  };
};
